<template>
  <header id="main-header" :class="getMainClass()">
    <div v-if="window > 980" class="main-menu">
      <h1 v-if="useNativeLinksInLogo && useNativeLinks">
        <a href="/" title="Ylands" class="logo">
          <YlandsLogo />
        </a>
      </h1>
      <h1 v-else class="logo">
        <router-link :to="{ name: 'home' }" title="Ylands" class="logo">
          <YlandsLogo />
        </router-link>
      </h1>

      <ul id="nav-menu">
        <li>
          <a
            :class="{ 'router-link-active': alwaysActiveLink === 'play' }"
            v-if="useNativeLinks"
            title="Play Ylands"
            href="https://play.ylands.com/"
            >Play</a
          >
          <a
            v-else
            :class="{ 'router-link-active': alwaysActiveLink === 'play' }"
            href="/play"
            title="Play Ylands"
            >Play</a
          >
        </li>

        <li>
          <a
            :class="{
              'router-link-active': alwaysActiveLink === 'create'
            }"
            v-if="useNativeLinks"
            title="Create Ylands"
            href="https://create.ylands.com/"
            >Create</a
          >
          <a
            v-else
            :class="{ 'router-link-active': alwaysActiveLink === 'create' }"
            href="/create"
            title="Create Ylands"
            >Create</a
          >
        </li>

        <li>
          <a
            :class="{
              'router-link-active': alwaysActiveLink === 'community'
            }"
            v-if="useNativeLinks"
            title="Ylands Community Forums"
            href="https://ylands.com/community"
            >Community
            <OutsideLinkIcon class="outside-link-icon" />
          </a>
          <a
            v-else
            :class="{
              'router-link-active': alwaysActiveLink === 'community'
            }"
            href="/community"
            title="Ylands Community Forums"
            >Community <OutsideLinkIcon class="outside-link-icon"
          /></a>
        </li>
        <li>
          <a
            title="Bohemia Interactive Store"
            href="https://store.bistudio.com/"
            >Merch
            <OutsideLinkIcon class="outside-link-icon" />
          </a>
        </li>
        <li class="loginAccount">
          <Account
            class="mainMenuAccount"
            :login-url="loginUrl"
            :logout-url="logoutUrl"
            :user-data-url="userDataUrl"
            :user="userData"
          />
        </li>
      </ul>
    </div>

    <!-- -Hamburger -->

    <div class="hamburger-menu" v-if="window <= 980">
      <div
        class="burger-header"
        v-if="!showHamburgerMenu && !showUserAccountMenu"
      >
        <h1 v-if="useNativeLinksInLogo && useNativeLinks">
          <a href="/" title="Ylands">
            <YlandsLogo />
          </a>
        </h1>
        <h1 v-else>
          <router-link :to="{ name: 'home' }" title="Ylands" class="logo">
            <YlandsLogo />
          </router-link>
        </h1>

        <HamburgerIcon
          v-if="!showHamburgerMenu"
          @click="toggleHamburgerMenu(null)"
          class="nav-hamburger-icon"
        />
      </div>

      <transition name="slide-fade">
        <div class="hamburger-content" v-if="showHamburgerMenu">
          <HamburgerMenu
            id="nav-hamburger-content"
            @showUserAccountMenu="showUserMenu"
            @showHamburgerMenu="toggleHamburgerMenu"
            :show-user-account-menu="showUserAccountMenu"
            :show-hamburger-menu="showHamburgerMenu"
            :login-url="loginUrl"
            :logout-url="logoutUrl"
            :user-data-url="userDataUrl"
            :user-data="userData"
            :use-native-links="useNativeLinks"
            :always-active-link="alwaysActiveLink"
          />
          <HamburgerFooter v-if="!showUserAccountMenu" />
        </div>
      </transition>

      <!-- -UserAccountsMenu -->

      <transition name="slide-fade">
        <div
          class="user-account-list-menu"
          v-if="showUserAccountMenu && !showHamburgerMenu"
        >
          <UserAccountMenu
            @showUserAccountMenu="switchOffBurger"
            @showHamburgerMenu="toggleHamburgerMenu"
            :login-url="loginUrl"
            :logout-url="logoutUrl"
            :user-data-url="userDataUrl"
          />
        </div>
      </transition>
    </div>
  </header>
</template>
<script>
import YlandsLogo from "./icons/YlandsLogo";
import HamburgerMenu from "./header/HamburgerMenu.vue";
import HamburgerIcon from "../assets/svg/hamburger.svg?inline";
import HamburgerFooter from "../components/partial/HamburgerMenuFooter";
import OutsideLinkIcon from "../assets/svg/outside_link.svg?inline";
import Account from "./header/Account";
import UserAccountMenu from "./header/UserAccounts";

export default {
  name: "main-header",
  components: {
    YlandsLogo,
    HamburgerMenu,
    HamburgerIcon,
    HamburgerFooter,
    OutsideLinkIcon,
    Account,
    UserAccountMenu
  },
  data() {
    return {
      scrolled: false,
      showHamburgerMenu: false,
      window: window.innerWidth,
      showUserAccountMenu: false,
      browserWidthSmall: null
    };
  },
  props: {
    floating: {
      type: Boolean,
      default: true
    },
    userDataUrl: {
      type: String
    },
    userData: {
      type: Object
    },
    loginUrl: {
      type: String
    },
    logoutUrl: {
      type: String
    },
    useNativeLinks: {
      type: Boolean,
      default: false
    },
    useNativeLinksInLogo: {
      type: Boolean,
      default: false
    },
    hoverable: {
      type: Boolean,
      default: true
    },
    alwaysActiveLink: {
      type: String
    }
  },
  methods: {
    toggleHamburgerMenu(value) {
      if (!value) {
        this.showHamburgerMenu = !this.showHamburgerMenu;
      } else {
        this.showHamburgerMenu = value;
      }
    },
    getMainClass() {
      var classObject = {};

      if (this.hoverable) {
        classObject.scrolled = this.scrolled;
      } else {
        classObject["scrolled-no-hover"] = this.scrolled;
        classObject["no-hover"] = true;
      }

      classObject.floating = this.floating;
      return classObject;
    },
    handleScroll() {
      this.scrolled = window.pageYOffset > 0;
    },
    showUserMenu(value) {
      this.showUserAccountMenu = value;
      this.showHamburgerMenu = !this.showHamburgerMenu;
    },
    switchOffBurger() {
      this.showUserAccountMenu = false;
    },
    windowResize() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.window = window.innerWidth;
        if (this.window > 980) {
          this.showHamburgerMenu = false;
          this.showUserAccountMenu = false;
        }
      }, 0);
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.windowResize);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.windowResize);
  }
};
</script>
<style lang="scss">
#main-header {
  color: #2f475f;
  letter-spacing: 0.15px;
  width: 100%;
  z-index: 999;
  position: relative;
  font-size: 14px;
  height: 79px;

  @media (max-width: 1200px) {
    height: 67px;
  }
  @media (max-width: 768px) {
    height: 57px;
  }

  @media (max-width: 480px) {
    height: 48px;
  }

  * {
    box-sizing: border-box;
  }

  a {
    color: #fff;
    text-decoration: none;
  }
}

#main-header.scrolled,
#main-header.scrolled a {
  color: #fff;
}

@media (max-width: 1280px) {
  .hide-1280 {
    display: none !important;
  }
}

@media (max-width: 980px) {
  .hide-980 {
    display: none !important;
  }
}

@media (max-width: 480px) {
  .hide-480 {
    display: none !important;
  }
}
</style>

<style scoped lang="scss">
//TRANSITION//
.slide-fade-enter-active {
  transition: all 0.6s ease;
}

.slide-fade-enter {
  transform: translateX(100%);
  opacity: 0;
}

//MAIN-HEADER//
#main-header {
  width: 100%;
  z-index: 100;
  color: #2f475f;
  position: relative;
  display: flex;

  &.floating {
    position: fixed;
    top: 0;
    left: 0;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #fff;
    margin: 0 auto;
    list-style-type: none;
    letter-spacing: 1px;
    background-color: rgba(10, 41, 74, 0);
    padding: 0 2em 0 2em;
    transition: 0.5s background-color;
    max-width: 1920px;

    @media (max-width: 980px) {
      padding: 0;
    }
  }

  h1 {
    font-size: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  &.scrolled-no-hover {
    color: #fff;
    background-color: rgba(10, 41, 74, 1);
  }

  &.scrolled,
  &:not(.no-hover):hover {
    color: #fff;

    div {
      background-color: rgba(10, 41, 74, 1);
    }
  }
}

.no-hover {
  background-color: #0a294a;
}

.nav-links {
  color: #fff;
}

//NAV-BASIC//
.main-menu {
  flex: 1;
  #nav-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #fff;
    margin: 0;
    padding: 0;
    list-style-type: none;
    letter-spacing: 1px;
    flex: 1;
    justify-content: flex-end;
    height: 3em;

    &.scrolled {
      #nav-hamburger-content {
        @media (max-width: 980px) {
          background-color: rgba(10, 41, 74, 1);
        }
      }
    }

    li {
      display: inline-flex;
      align-items: center;
      margin: 0 25px 0 0;
      font-family: "Proxima Nova", sans-serif;

      a {
        width: 100%;
      }

      div {
        width: 100%;
      }

      .outside-link-icon {
        margin-left: 3px;
      }
    }

    .loginAccount {
      border-left: 1px solid white;

      .mainMenuAccount {
        margin-left: 10px;
      }

      .user-account-menu {
        li {
          margin-right: 0px;
        }
      }
    }

    a {
      &.buy-button {
        background-color: #ffa206 !important;
        padding: 0.4em 1em;
        border-radius: 3px;
        line-height: 1.5;

        @media (max-width: 980px) {
          padding: 2em 2em;
          border-radius: 0;
        }
      }
    }

    li > a {
      &:hover,
      &.router-link-active {
        text-shadow: 0 0 1px #fff;
      }
    }

    .nav-link {
      &:hover,
      &.router-link-active {
        text-shadow: 0 0 1px #fff;
      }
    }

    @media (max-width: 980px) {
      display: none;
    }
  }
}

//HAMBURGER//
.hamburger-menu {
  flex: 1;
  .burger-header {
    display: flex;
    flex-direction: row;
    padding: 0 1.5em;
    right: 0;
    background: rgba(10, 41, 74, 1);
    top: 0;
    left: 0;
    flex: 1;
    width: 100%;
    position: fixed;
    height: 79px;

    @media (max-width: 1200px) {
      height: 67px;
    }

    @media (max-width: 768px) {
      height: 57px;
    }

    @media (max-width: 480px) {
      height: 48px;
    }

    .chevron-back {
      position: absolute;
      left: 2.7em;
      &:hover {
        filter: drop-shadow(0 0 0.75rem #fff);
      }
    }

    .nav-hamburger-icon {
      margin: auto 0 auto 0;
      display: inline-block;
      cursor: pointer;
      opacity: 1;

      &:hover {
        opacity: 0.8;
      }
    }
    .nav-close-icon {
      margin: auto 0 auto 0;
      cursor: pointer;
    }

    h1 {
      flex: 1;
      display: flex;
      vertical-align: center;
    }

    .logo {
      margin: auto 0 auto 0;
      height: 30px;
      width: auto;
    }
  }

  .hamburger-content {
    padding: 1em 2em;
    display: flex;
    flex-direction: column;
    position: fixed;
    width: 100%;
    height: 100vh;
    min-height: 350px;
    right: 0;
    background: rgba(10, 41, 74, 1);
    top: 0;
    left: 0;
    z-index: 3;

    h1 {
      display: flex;
      justify-content: space-between;

      svg {
        text-align: center;
        margin: auto 0 auto 0;
        cursor: pointer;
        &:hover {
          filter: drop-shadow(0 0 0.75rem #fff);
        }
      }
    }
  }

  .user-account-list-menu {
    width: 100%;
    height: 100vh;
    min-height: 350px;
    background: rgba(10, 41, 74, 1);
    display: flex;
    flex-direction: column;
    position: fixed;
    width: 100%;
    height: 100vh;
    min-height: 350px;
    right: 0;
    top: 0;
    left: 0;
    z-index: 5;
  }
}
</style>
